export default __webpack_public_path__ + "static/media/various-doctor-hospital-medical.0e56b3bb.jpg";